<script>
import { BFormRadio } from "bootstrap-vue";

export default {
  extends: BFormRadio
};
</script>